import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../../../Components/CustomSnackbar';
import React, { useState, useEffect } from 'react';
import { loadingCassetteDataComponent, loadingDividerDataComponent } from '../../../LoadingData/LoadingDataComponents';
import { UpdateCassetteDescription, UpdateCassetteModel, UpdateDividerDescription, UpdateDividerModel } from '../../../UpdateData/UpdateCommunications';
import { DELETE_CASSETTE_ID_API_URL, DELETE_DIVIDER_ID_API_URL } from '../../../OpticApiConfig';
import Select from 'react-select';
import { UpdateDividerKtvComponents, UpdateDividerPonComponents } from '../../../UpdateData/UpdateStatusComponent';


const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '14px',
    border: '1px solid #ffffff',
    marginBottom: '5px',
    marginTop: '10px',
    width: '280px'
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
    
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
    fontSize: '14px',
    width: '280px'
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};

const CassetteNodeCantonEditingDialog = ({ open, onClose, content, cantonRefresh}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [cassetteData, setCassetteData] = useState([]);
  const token = localStorage.getItem('token');
  const [statusChange, setStatusChange] = useState(false);
  const [textComment, setTextComment] = useState(content.description || "");
  const [cassetteId, setCassetteId] = useState("");

// Обновляем состояние при изменении `content`
useEffect(() => {
  setTextComment(content.description || "");
}, [content.description]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [cassetteData, rankComponentData] = await Promise.all([
          loadingCassetteDataComponent(),
          //loadingRankComponentDataComponent(),
        ]);
        setCassetteData(cassetteData);
       // setRankComponentData(rankComponentData);
      } catch (error) {
        // console.error("Error in fetchData:", error);
      }
    };
    fetchData();
  }, []);

  
  const handleCloseDialogs = () => {    
    cantonRefresh();
       onClose(); 
  };

   const deleteCassette = async () => {
  
          if (!token) {
              showSnackbar('Ошибка! Токен не найден', 'snackbarWarning');
              return;
          }

          try {
              let apiDivider = `${DELETE_CASSETTE_ID_API_URL}?cassetteId=${content.id}`;

              const response = await fetch(apiDivider, { 
                  method: 'DELETE',
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${token}` 
                  }
              });
  
              if (response.ok) {
                  showSnackbar('Компонент успешно удален', 'snackbarWarning');
                  setCassetteData([]);
                  setCassetteId("");
                  cantonRefresh();
                  onClose();
              } else {
                  showSnackbar('Ошибка удаления!', 'snackbarWarning');
              }
          } catch (error) {
              showSnackbar('Произошла ошибка!', 'snackbarWarning');
          }  
      };


      const handleDescriptionChange = (event) => {
        const newText = event.target.value;
        setTextComment(newText);
    
        if (newText !== content.comment) {
            setStatusChange(true);
        } else {
            setStatusChange(false);
        }
     };


    
  const updateCassetteModel = () => {
   
     if (cassetteId === "") {
       showSnackbar('Нет нужды в записи, кассета без изменений!', 'snackbarOk');
     } else {
       UpdateCassetteModel(content.id, cassetteId, showSnackbar);
     } 
   };

   const updateDescription = () => {
      if (statusChange) {
        UpdateCassetteDescription(content.id, textComment, showSnackbar);
      } else {
        showSnackbar('Нет нужды в записи, текст без изменений!', 'snackbarOk');
      }
    };

    const handleChangeCassetteSelect = (event) => {
      const selectedCassette = event.target.value;
      if (selectedCassette === "") {
        setCassetteId("");
      } else {
        const selectedCassette2 = cassetteData.find(cassette => 
          `${cassette.id}` === selectedCassette
        );
        if (selectedCassette2) {
          setCassetteId(selectedCassette2.id);
        }
      }
    };

    return (
  
    <Dialog open={open} className="dialogStyle" >
    
      <DialogContent style={{height: 'auto'}}>
     
      <img 
        src={"./cassette.png"} 
        width="40" 
        height="40" 
        style={{ marginRight: "5px" }} 
        alt="Divider"
      />
       
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset'}}>Редактирование кассеты</label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe' }}>{content.id}</span></label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold', marginRight: "5px"}}>Кассета</label>
      <select className="selectStyleDrawer" 
        onChange={(event) => {
          handleChangeCassetteSelect(event);
        }} >
        <option value="">{content.model}</option>
        {cassetteData.map(cassette => (
          <option key={cassette.id} value={cassette.id}>{cassette.model}</option>
        ))}
        </select>
        <button onClick={updateCassetteModel} class='buttonIsSaveDialog2'>Сохранить</button>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/>

      <label style={{ color: '#292929', fontWeight: 'bold'}}>Коммент:</label>
      <textarea
          className="textAreaEditingModal"
          value={textComment}       
          onChange={handleDescriptionChange} 
        />
         <br/>
         <button  class='buttonIsSaveDialog2' onClick={updateDescription} style={{fontSize: '14px', paddingTop: '3px', paddingBottom: '3px'}}>Сохранить</button>
         <br/> <br/>
       <hr className='horizontalLineDialog'/>
      
      <button onClick={deleteCassette} class='buttonIsDeleteModal2' style={{marginLeft:"0px"}}>Удалить</button>
      

      </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} class='buttonIsHideDrawer23'>
            Закрыть
          </Button>
        </DialogActions>


       {/* Snackbar */}
       <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

      
    </Dialog>
  );
}

export default CassetteNodeCantonEditingDialog;